
const state = {
  loginType: 'login',
  token: localStorage.getItem('token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  isLoggedIn: !!localStorage.getItem('token')
}

const mutations = {
  SET_LOGIN_TYPE: (state, type) => {
    state.loginType = type
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    state.isLoggedIn = !!token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    if (userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('userInfo')
    }
  },
  CLEAR_USER: (state) => {
    state.token = ''
    state.userInfo = {}
    state.isLoggedIn = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  // 登录
  async login({ commit }, { token, userInfo }) {
    // 先设置token，确保后续API调用有权限
    commit('SET_TOKEN', token)
    
    // 如果是新注册用户且没有头像，设置默认头像
    if (userInfo && !userInfo.avatar) {
      userInfo = {
        ...userInfo,
        avatar: '/default-avatar.png' // 设置默认头像路径
      }
    }
    
    commit('SET_USER_INFO', userInfo)
    return Promise.resolve()
  },
  
  // 登出
  logout({ commit }) {
    commit('CLEAR_USER')
    return Promise.resolve()
  },
  
  // 重置token
  resetToken({ commit }) {
    commit('CLEAR_USER')
    return Promise.resolve()
  },
  
  // 更新用户信息
  updateUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
    return Promise.resolve()
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isLoggedIn: state => state.isLoggedIn,
  loginType: state => state.loginType
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
